module.exports = __webpack_public_path__ + "img/maintenance.35ae8822.svg";